var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrorDownIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 4,
    viewBox: "0 0 8 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.21953 3.91561L7.90953 0.489905C8.03036 0.377666 8.03016 0.195949 7.90891 0.0838976C7.78767 -0.0280667 7.59128 -0.0277774 7.47036 0.0844762L3.99999 3.30627L0.529623 0.0843602C0.408686 -0.027879 0.212421 -0.0281683 0.0911719 0.0837815C0.0303908 0.139952 -9.22483e-09 0.213539 -1.24414e-08 0.287125C-1.56498e-08 0.360524 0.0301876 0.433822 0.0905467 0.489891L3.78045 3.91561C3.83855 3.96967 3.91761 4 3.99999 4C4.08236 4 4.16133 3.96958 4.21953 3.91561Z",
    fill: "#219EBC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrorDownIcon);
export default __webpack_public_path__ + "static/media/arrorDown_icon.e571a3d7a5e69776a1b3af522fdd2f5d.svg";
export { ForwardRef as ReactComponent };